<template><!-- svgo-optimised -->
<svg class="icon icon__play" width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
  <circle opacity="0.5" cx="10" cy="10" r="10" fill="white" stroke-width="0"/>
  <path d="M8 13.3334V6.66669L13.3333 9.52383L8 13.3334Z" fill="white"/>
</svg>
</template>